<mat-form-field>
    <mat-select placeholder="{{ 'Login.Role' | translate }}" [(value)]="selectedRoleId">
        @for (role of roles(); track role.id) {
            <mat-option [value]="role.id" [id]="role.id">
                {{ role.name }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
@for (role of roles(); track role.id) {
    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
    @if (role.id == selectedRoleId()) {
        <sl-home class="flex-grow-1" [editLayoutDefaultSettingsRoleId]="role.id" />
    }
}
